import { EventsEnum } from '@hubxtech/hubx-client-analytics-package/lib/src/enum/pdfGenius/eventsEnum';

import {
  resolveSourceParam,
  type LogHubxEventParams,
} from '@/lib/analytics/services/log-hubx-event-adapter';
import { store } from '@/store';

import { REVIEW_HAPPY_MOMENT_DEDUP_MS } from '../constants';
import { registerHappyMoment } from '../store/reviewSlice';
import { persistHappyMoment } from './reviewFlowService';
import { incrementReviewFlowTrigger } from './reviewFlowTriggers';

const DOWNLOAD_SUCCESS_EVENTS = new Set<string>([
  EventsEnum.DOWNLOAD_SUCCESS,
  EventsEnum.AUTO_DOWNLOAD_SUCCESS,
]);

let lastHappyMomentAt = 0;

export function trackReviewHappyMoment(args: {
  eventName: string;
  params: LogHubxEventParams;
}): void {
  const { eventName, params } = args;
  if (!DOWNLOAD_SUCCESS_EVENTS.has(eventName)) return;

  const now = Date.now();
  if (now - lastHappyMomentAt < REVIEW_HAPPY_MOMENT_DEDUP_MS) return;
  lastHappyMomentAt = now;

  const featureName = resolveSourceParam(params) ?? null;
  incrementReviewFlowTrigger('download_success', featureName);

  const rootState = store.getState();
  const review = rootState.review;

  if (!review || review.reviewFlow !== 1 || !review.stateLoaded) return;

  const uid = rootState.auth?.user?.uid;
  if (!uid) return;

  store.dispatch(registerHappyMoment());

  const updated = store.getState().review;
  void persistHappyMoment(uid, updated.happyMomentCount);
}
